import Svg, { Path } from 'react-native-svg';

export function ShowIcon({ width, height, color = '#FFFFFF' }: any) {  return (
    <Svg width={width ?? 24} height={height ?? 24} viewBox={`0 0 ${width ?? 24} ${height ?? 24}` } fill="none">
        
        <Path 
            d="M3 11.9985C3 11.9985 6.27273 5.19531 12 5.19531C17.7273 5.19531 21 11.9985 21 11.9985C21 11.9985 17.7273 18.8016 12 18.8016C6.27273 18.8016 3 11.9985 3 11.9985Z"
            stroke={color}
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <Path 
            d="M12.0014 14.456C13.357 14.456 14.456 13.357 14.456 12.0014C14.456 10.6458 13.357 9.54688 12.0014 9.54688C10.6458 9.54688 9.54688 10.6458 9.54688 12.0014C9.54688 13.357 10.6458 14.456 12.0014 14.456Z"
            stroke={color}
            strokeWidth={1.5}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Svg>

  );
};
